export enum PinDebitInjectionOptions {
  tsysBBVA5B1120 = 'TSYS-BBVA 5B1120',
  tsysEvolveBankAndTrust5B1138 = 'TSYS-Evolve Bank and Trust 5B1138',
  tsysTangramTDES = 'TSYS-Tangram TDES',
}
